import { CustomNotification } from '@app/admin/notifications/custom-notification';
import { useActiveNotifications } from '@app/admin/notifications/requests/use-active-notifications';
import { Link } from 'react-router';
import { slugifyString } from '@ui/utils/string/slugify-string';

interface CustomNotificationListProps {
    className?: string;
}

export function CustomNotificationList({ className }: CustomNotificationListProps) {
    const { data } = useActiveNotifications();

    if (!data?.notifications?.length) {
        return null;
    }

    return (
        <div className={className}>
            {data.notifications.map(notification => (
                <CustomNotificationItem key={notification.id} notification={notification} />
            ))}
        </div>
    );
}

interface CustomNotificationItemProps {
    notification: CustomNotification;
}

function CustomNotificationItem({ notification }: CustomNotificationItemProps) {
    // Build title link using linked_title data
    const getTitleUrl = () => {
        if (notification.linked_title) {
            const slug = slugifyString(notification.linked_title.name);
            return `/titles/${notification.linked_title.id}/${slug}`;
        }
        return undefined;
    };

    // Priority: custom link > title page > no link
    const linkTo = notification.link
        ? notification.link
        : getTitleUrl();

    const content = (
        <div className="flex gap-14 px-20 py-16 hover:bg-hover transition-colors border-b border-white/5">
            {/* Imagem Landscape */}
            {notification.display_image && (
                <div
                    className="flex-shrink-0 rounded overflow-hidden bg-zinc-800"
                    style={{ width: '120px', height: '68px' }}
                >
                    <img
                        src={notification.display_image}
                        alt={notification.title}
                        className="w-full h-full object-cover"
                    />
                </div>
            )}

            {/* Conteúdo */}
            <div className="flex-1 min-w-0">
                <h4 className="font-semibold text-sm text-white line-clamp-1">
                    {notification.title}
                </h4>
                {notification.description && (
                    <p className="text-xs text-muted line-clamp-2 mt-4">
                        {notification.description}
                    </p>
                )}
            </div>
        </div>
    );

    if (linkTo) {
        const isExternal = linkTo.startsWith('http://') || linkTo.startsWith('https://');

        if (isExternal) {
            return (
                <a href={linkTo} target="_blank" rel="noopener noreferrer" className="block">
                    {content}
                </a>
            );
        }

        return (
            <Link to={linkTo} className="block">
                {content}
            </Link>
        );
    }

    return content;
}
